import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['name', 'ppEnv']
  static values = { format: String, name: String, ppEnv: String }

  initialize() {
    this.formatValue = this.formatVal()
    this.ppEnvValue = this.ppEnvTarget.dataset.env
    let waitTime;
    if (typeof(window.paypal) == 'undefined') {
      waitTime = 500
    } else {
      waitTime = 0
    }
    this.delayInit(waitTime)
  }

  delayInit(waitTime) {
    const self = this
    setTimeout(function() {
      if (typeof(window.paypal) == 'undefined') {
        delayInit(500)
        return
      }
      self.initPayPal()
      // show total price on page
      self.formatChange()

      // show field errors and enable/disable buttons
      self.checkFormValid()
    }, waitTime)
  }

  performInit() {
    this.initPayPal()
    // show total price on page
    this.formatChange()

    // show field errors and enable/disable buttons
    this.checkFormValid()
  }

  initPayPal() {
    window.call_sign = function() {
      return document.getElementById('order_call_sign').value
    }
    window.order_name = function() {
      return document.getElementById('order_name').value
    }
    window.certificate_format = function() {
      if (document.getElementById('order_certificate_format_paper').checked) {
        return 'paper'
      } else if (document.getElementById('order_certificate_format_pdf').checked) {
        return 'pdf'
      }
    }
    window.order_country = function() {
      const checked = document.querySelector('input[name="order[country]"]:checked')
      return checked ? checked.value : 'us'
    }
    window.certificate_type = function() {
      return document.getElementById('order_certificate_type').value
    }
    window.showAlert = function (text) {
      const alertEle = document.getElementById('form-alert')
      if (!alertEle) { return }
      alertEle.innerHTML = '<div class="row my-2 px-1">' +
                             '<div class="alert alert-danger alert-dismissible fade show">' +
                             text +
                             '<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>' +
                             '</div>' +
                           '</div>'
    }
    window.paypal.Buttons({
      env: this.ppEnvValue,
      onInit: function(data, actions)  {
        actions.disable()
        const checkEle = document.getElementById('order_form_check')
        checkEle.addEventListener('change', function(event) {
          // Enable or disable the button when it is checked or unchecked
          if (event.target.checked)  {
            actions.enable()
          } else  {
            actions.disable()
          }
        })
      },
      onClick: function(data, actions) {
        // console.log('on click event fired')
      },
      createOrder: async () => {
        const params = {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            order: {
              call_sign: window.call_sign(),
              certificate_type: window.certificate_type(),
              certificate_format: window.certificate_format(),
              name: window.order_name(),
              country: window.order_country()
            }
          })
        }
        const response = await fetch('/orders', params)
        const responseData = await response.json();
        if (responseData.errors) {
          window.showAlert(responseData.errors)
          return null
          // cancel?
        }
        return responseData.token
      },
      onShippingAddressChange: (data, actions) => {
        if (window.certificate_format() === 'paper' && !['US', 'CA'].includes(data.shippingAddress.countryCode)) {
          return actions.reject()
        }
      },
      onApprove: async (data) => {
        const response = await fetch('/orders/capture', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ order_id: data.orderID })
        });
        if (response.ok) {
          window.location.reload()
          return
        }
        let responseData = {}
        try { responseData = await response.json() } catch (_e) { /* non-JSON error body */ }
        const message = responseData.instrument_declined
          ? 'Your payment was declined. Please try again, or use a different card or payment method.'
          : (responseData.error || 'Your payment could not be completed. Please try again.')
        window.showAlert(message)
        // actions.restart() is a no-op on PayPal's newer checkout flow and leaves
        // the popup spinning, so abort the approval instead: the popup closes and
        // the buyer can click the PayPal button again to retry with another method.
        throw new Error(message)
      },
      onError: function(info) {
        return false
      }
    }).render('#paypal-button-container');
  }

  countryChange(_event) {
    const international = this.countryVal() === 'other'
    const paperRadio = document.getElementById('order_certificate_format_paper')
    paperRadio.disabled = international
    if (international && paperRadio.checked) {
      document.getElementById('order_certificate_format_pdf').checked = true
      this.formatChange()
    }
  }

  countryVal() {
    const checked = document.querySelector('input[name="order[country]"]:checked')
    return checked ? checked.value : 'us'
  }

  formatChange(_event) {
    this.formatValue = this.formatVal()
    let totalCost;
    if (this.formatValue == 'pdf') {
      totalCost = '$5.00'
    } else {
      totalCost = '$10'
    }
    document.getElementById('order_total').innerText = totalCost
  }

  formatVal() {
    return document.querySelector('input[name="order[certificate_format]"]:checked').value
  }

  nameEle() {
    return document.querySelector('input[name="order[name]"]')
  }

  checkFormValid() {
    const ppButtons = document.getElementById('paypal-button-container')
    if (this.checkNameValid()) {
      document.getElementById('order_form_check').checked = true
      document.getElementById('order_form_check').dispatchEvent(new Event('change'))
      return true
    } else {
      document.getElementById('order_form_check').checked = false
      document.getElementById('order_form_check').dispatchEvent(new Event('change'))
      return false
    }
  }

  nameChange(_event) {
    this.nameValue = this.nameVal()
    this.checkFormValid()
  }

  checkNameValid() {
    let ele = this.nameEle()
    if (this.nameValid()) {
      ele.classList.add('is-valid')
      ele.classList.remove('is-invalid')
      return true
    } else {
      ele.classList.add('is-invalid')
      ele.classList.remove('is-valid')
      return false
    }
  }

  nameValid() {
    return this.nameValue.length >= 3
  }

  nameVal() {
    return this.nameTarget.value
  }
}
